import { Injectable } from '@angular/core';
import { ServiceCategoriesDataService } from '../data-services/service-categories-data.service';

@Injectable({
    providedIn: 'root'
})

export class ServiceCategoriesBusinessService {
    constructor(private service: ServiceCategoriesDataService) {
    }
    serviceCategoryId:number
    getServiceCategories(language:string): Promise<any> {
        return this.service.getServiceCategories(language);
    }

    addUpdateServiceCategories(model: any): Promise<any> {
        return this.service.addUpdateServiceCategories(model);
    }
    getByIdServiceCategories(id: any): Promise<any> {
        return this.service.getByIdServiceCategories(id);
    }
    deleteServiceCategories(id: any): Promise<any> {
        return this.service.deleteServiceCategories(id);
    }
}